import { render, staticRenderFns } from "./UpdateDetailsForm.vue?vue&type=template&id=7107af0b&scoped=true&"
import script from "./UpdateDetailsForm.vue?vue&type=script&lang=js&"
export * from "./UpdateDetailsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7107af0b",
  null
  
)

export default component.exports